import { render, staticRenderFns } from "./PrintBillBearK80.vue?vue&type=template&id=3af36347&scoped=true"
import script from "./PrintBillBearK80.vue?vue&type=script&lang=js"
export * from "./PrintBillBearK80.vue?vue&type=script&lang=js"
import style0 from "./PrintBillBearK80.vue?vue&type=style&index=0&id=3af36347&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af36347",
  null
  
)

export default component.exports